import React, { useState } from 'react';
import { Calendar, X } from 'lucide-react';

interface DateRangePickerProps {
  onDateSelect: (startDate: Date | null, endDate: Date | null) => void;
  className?: string;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ onDateSelect, className = '' }) => {
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = e.target.value;
    setStartDate(date);
    onDateSelect(date ? new Date(date) : null, endDate ? new Date(endDate) : null);
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = e.target.value;
    setEndDate(date);
    onDateSelect(startDate ? new Date(startDate) : null, date ? new Date(date) : null);
  };

  const handleClear = () => {
    setStartDate('');
    setEndDate('');
    onDateSelect(null, null);
  };

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <Calendar className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
      <input
        type="date"
        value={startDate}
        onChange={handleStartDateChange}
        max={endDate || undefined}
        className="flex-1 min-w-0 px-1.5 py-1 bg-background border border-border rounded text-foreground text-[11px] focus:outline-none focus:ring-1 focus:ring-primary"
        title="Start date"
      />
      <span className="text-muted-foreground text-[10px] shrink-0">—</span>
      <input
        type="date"
        value={endDate}
        onChange={handleEndDateChange}
        min={startDate || undefined}
        className="flex-1 min-w-0 px-1.5 py-1 bg-background border border-border rounded text-foreground text-[11px] focus:outline-none focus:ring-1 focus:ring-primary"
        title="End date"
      />
      {(startDate || endDate) && (
        <button onClick={handleClear} className="p-0.5 hover:bg-muted rounded shrink-0" title="Clear">
          <X className="w-3 h-3 text-muted-foreground" />
        </button>
      )}
    </div>
  );
};

export default DateRangePicker;
